import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { stepIndices } from './import_constants';

export class StepList extends React.Component {
  static propTypes = {
    currentStep: PropTypes.string.isRequired,
    disabledSteps: PropTypes.array.isRequired,
    stepLabels: PropTypes.object.isRequired,
    stepLinks: PropTypes.object.isRequired,
    stepTitles: PropTypes.object.isRequired,
  }

  stepClass(step) {
    const { disabledSteps, currentStep } = this.props;

    if (currentStep == step) {
      return "active";
    } else if (disabledSteps.includes(step)) {
      return "disabled";
    }
  }

  renderStepsList() {
    const { stepLinks, stepLabels } = this.props;

    return Object.keys(stepIndices).map((step) => {
      const stepClass = this.stepClass(step);
      return (
        <li className={stepClass} key={step}>
          <a href={stepLinks[step]}>
            <h1 className="list-group-item-heading">{stepIndices[step]}</h1>
            <p className="list-group-item-text">{stepLabels[step]}</p>
          </a>
        </li>
      );
    });
  }

  render() {
    const { currentStep, stepTitles } = this.props;
    return (
      <div className="container list-container">
        <div className="pv-5">
          <div className="step-title h3">Step {currentStep} - {stepTitles[currentStep]}</div>
          <ul className="nav nav-pills nav-justified thumbnail setup-panel">
            {this.renderStepsList()}
          </ul>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  ...state.ui
});

export default connect(mapStateToProps)(StepList);
